// extracted by mini-css-extract-plugin
export default {"fontFamily":"Admins_fontFamily__wl6GP","tableBg":"Admins_tableBg__hnLJU"};